import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import VM from 'scratch-vm';
import store from 'store';

import {
    openAddPage,
    isPortOpen,
    getPortNumber,
    isCheckingImportDevice
} from '../../../reducers/device-manager-controller';

import {
    hoverDevice,
    cleanPortOption,
} from '../../../reducers/select-option';

import { uiType, getUIStyle } from '../../../reducers/ui-style';

import {
    isDeleteDeviceMode,
} from '../../../reducers/delete-device';

import {
    showDeviceHelpDialog,
    isDeviceHelpDialogShow,
    showVisionTutorialDialog,
    showVisionSettingDialog,
    isVisionSettingDialogShow,
    hideStreamingDialog
} from '../../../reducers/dialog';
import {
    isTagInformationEnable,
    COLOR_DATA_LIST,
    IS_TAG_INFORMATION_ENABLE,
    QRCODE_RESULT,
    DEFAULT_COLOR_DATA_LIST,

    setLaunchSettingWay,
    LAUNCH_FROM,
} from '../../../reducers/vision';
import {
    getPlatform
} from '../../../lib/platform'

import drivetrain from '../pictures/device_drivetrain_icon.svg';
import motor100 from '../pictures/device_motor_icon.svg';
import motor300 from '../pictures/device_motor_icon.svg';
import vision from '../pictures/device_visionsensor_icon.svg';
import speaker from '../pictures/device_mic_speaker_icon.svg';
import gyro from '../pictures/device_gyro_icon.svg';
import touchLed from '../pictures/device_touchled_icon.svg';
import colorSensor from '../pictures/device_colorsensor_icon.svg';
import help from '../pictures/help.svg';

import drivetrainWW from '../pictures/ww/device_drivetrain_icon.svg';
import motor100WW from '../pictures/ww/device_motor_icon.svg';
import motor300WW from '../pictures/ww/device_motor_icon.svg';
import visionWW from '../pictures/ww/device_visionsensor_icon.svg';
import speakerWW from '../pictures/ww/device_mic_speaker_icon.svg';
import gyroWW from '../pictures/ww/device_gyro_icon.svg';
import touchLedWW from '../pictures/ww/device_touchled_icon.svg';
import colorSensorWW from '../pictures/ww/device_colorsensor_icon.svg';
import helpWW from '../pictures/ww/help.svg';

import styles from './device-list.css';
import classNames from 'classnames';

import { DeviceItem } from './device-list-component.jsx'

const messages = defineMessages({
    selectDeviceTitle: {
        defaultMessage: "Select device",
        description: "Select device title",
        id: "gui.deviceList.selectDeviceTitle"
    },
    drivetrain: {
        defaultMessage: "Power Train",
        description: "drivetrain",
        id: "gui.device.drivetrain"
    },
    motor100: {
        defaultMessage: "Motor100",
        description: "motor100",
        id: "gui.device.motor100"
    },
    motor300: {
        defaultMessage: "Motor300",
        description: "motor300",
        id: "gui.device.motor300"
    },
    colorSensor: {
        defaultMessage: "Color",
        description: "Color Sensor",
        id: "gui.device.colorSensor"
    },
    touchLed: {
        defaultMessage: "TouchLED",
        description: "Touch LED",
        id: "gui.device.touchLed"
    },
    gyro: {
        defaultMessage: "Gyro",
        description: "Gyro",
        id: "gui.device.gyro"
    },
    vision: {
        defaultMessage: "Vision",
        description: "Vision",
        id: "gui.device.vision"
    },
    speaker: {
        defaultMessage: "Sound",
        description: "Mic Speaker",
        id: "gui.device.speaker"
    }
})

const imageTypes = {
    drivetrain: drivetrain,
    motor100: motor100,
    motor300: motor300,
    colorSensor: colorSensor,
    touchLed: touchLed,
    gyro: gyro,
    vision: vision,
    speaker: speaker,
    drivetrainWW: drivetrainWW,
    motor100WW: motor100WW,
    motor300WW: motor300WW,
    colorSensorWW: colorSensorWW,
    touchLedWW: touchLedWW,
    gyroWW: gyroWW,
    visionWW: visionWW,
    speakerWW: speakerWW,
}

const supportTypes = {
    drivetrain: 'drivetrain',
    motor100: 'motor100',
    motor300: 'motor300',
    colorSensor: 'colorSensor',
    touchLed: 'touchLed',
    gyro: 'gyro',
    vision: 'vision',
    speaker: 'speaker',
}

const DEVICE_LIST = "EntryDeviceList"

class EntryDeviceList extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
        ]);
        this.state = {
            selectedRadio: null,
            skipedDeviceHint: store.get('skipedDeviceHint'),
            refreshByImport: false,
            refreshByVision: false,
            hoverDevice: ''
        }
    }

    skipHint() {
        if (!this.state.skipedDeviceHint) {
            this.setState({ skipedDeviceHint: true });
            store.set('skipedDeviceHint', true);
        }
    }

    handleClickDevice(deviceType) {
        if (this.isDeviceEnable(deviceType)) {
            this.skipHint();
            if (deviceType == supportTypes.vision) {
                this.openCvDialog()
            } else {
                this.props.openAddPage(this.props.portNumber, deviceType)
            }
            this.props.cleanPortOption()
        }
    }

    openCvDialog() {
        if (!store.get('skipVisionTutorial')) {
            this.props.showVisionTutorialDialog();
        } else {
            this.props.showVisionSettingDialog();
        }
        this.props.setLaunchSettingWay(LAUNCH_FROM.ADD)
        if (!store.get('visionData')) {
            store.set('visionData', {
                [COLOR_DATA_LIST]: DEFAULT_COLOR_DATA_LIST,
                [IS_TAG_INFORMATION_ENABLE]: this.props.isTagInformationEnable,
            })
        }
    }

    handleClickHelp() {
        this.skipHint();
        this.props.openHelpDialog();
    }

    handleHoverDevice(deviceType) {
        if (this.isDeviceEnable(deviceType)) {
            let request = this.props.vm.getRequestPort(deviceType, this.props.brainType);
            let availablePort = this.props.vm.getAvailablePortAmount(this.props.brainType);
            let hintArray = [];
            if (request && request.smart > 0) hintArray = hintArray.concat(availablePort.smart);
            if (request && request.typeC > 0) hintArray = hintArray.concat(availablePort.typeC);
            this.props.hoverDevice(hintArray);
            this.setState({ hoverDevice: deviceType });
        }
    }

    handleHoverOff() {
        if (!this.props.isDeleteDeviceMode) {
            this.props.cleanPortOption();
            this.setState({ hoverDevice: '' });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.portNumber !== prevProps.portNumber || this.props.isDeleteDeviceMode !== prevProps.isDeleteDeviceMode) {
            this.setState({ selectedRadio: null })
        }
        if (prevProps.isCheckingImportDevice !== this.props.isCheckingImportDevice) {
            this.setState({ refreshByImport: this.props.isCheckingImportDevice });
        }
        if (this.props.isVisionSettingDialogShow != prevProps.isVisionSettingDialogShow) {
            this.setState({ refreshByVision: this.props.isVisionSettingDialogShow });
        }
    }

    isDeviceEnable(deviceType) {
        return this.props.vm.isDeviceAvailableToAdd(deviceType, this.props.brainType) && this.props.vm.isPortEnoughForDeviceToAdd(deviceType, this.props.brainType) && !this.props.isDeleteDeviceMode
    }

    getDeviceItem(deviceType) {
        return (
            <DeviceItem
                handleClickDevice={() => this.handleClickDevice(deviceType)}
                handleHoverDevice={() => this.handleHoverDevice(deviceType)}
                handleHoverOff={() => this.handleHoverOff()}
                isDeviceEnable={this.isDeviceEnable(deviceType)}
                isHover={this.state.hoverDevice == deviceType}
                image={this.props.getUIStyle == uiType.ww ? imageTypes[deviceType + 'WW'] : imageTypes[deviceType]}
                type={deviceType}
                deviceList={DEVICE_LIST}
                isChecked={this.state.selectedRadio === deviceType}
                messages={messages}
            />
        )
    }

    render() {
        if (!this.props.show) {
            return null;
        }
        return (
            <div className={classNames(styles.content)}>
                <div className={classNames(styles.selectDeviceTitle)}>
                    <FormattedMessage
                        {...messages.selectDeviceTitle}
                    />
                    <img className={classNames(styles.help,
                        (this.state.skipedDeviceHint) ? null : styles.breatheHelp)}
                        src={this.props.getUIStyle == uiType.ww ? helpWW : help}
                        onClick={() => { this.handleClickHelp() }}
                        alt={"help icon"} />
                </div>
                <div className={classNames(styles.tableArea)}>
                    <table className={classNames(styles.tableContent)}>
                        <tbody>
                            <tr>
                                {this.getDeviceItem(supportTypes.drivetrain)}
                                {this.getDeviceItem(supportTypes.motor100)}
                                {this.getDeviceItem(supportTypes.motor300)}
                                {this.getDeviceItem(supportTypes.vision)}
                            </tr>
                            <tr>
                                {this.getDeviceItem(supportTypes.speaker)}
                                {this.getDeviceItem(supportTypes.gyro)}
                                {this.getDeviceItem(supportTypes.touchLed)}
                                {this.getDeviceItem(supportTypes.colorSensor)}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div >
        );
    }
}

EntryDeviceList.propTypes = {
    init: PropTypes.bool,
    show: PropTypes.bool,
    portNumber: PropTypes.string,
    hoverDevice: PropTypes.func,
    cleanPortOption: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired,
    brainType: PropTypes.string
};

const mapStateToProps = state => ({
    show: isPortOpen(state),
    portNumber: getPortNumber(state),
    isDeleteDeviceMode: isDeleteDeviceMode(state),
    isDeviceHelpDialogShow: isDeviceHelpDialogShow(state),
    getUIStyle: getUIStyle(state),
    isCheckingImportDevice: isCheckingImportDevice(state),
    isVisionSettingDialogShow: isVisionSettingDialogShow(state),
});

const mapDispatchToProps = dispatch => ({
    openAddPage: (portNum, deviceType) => {
        dispatch(openAddPage(portNum, deviceType))
    },
    hoverDevice: (portArray) => { dispatch(hoverDevice(portArray)) },
    cleanPortOption: () => dispatch(cleanPortOption()),
    openHelpDialog: () => dispatch(showDeviceHelpDialog(getPlatform())),
    showVisionTutorialDialog: () => dispatch(showVisionTutorialDialog()),
    showVisionSettingDialog: () => {
        dispatch(hideStreamingDialog())
        dispatch(showVisionSettingDialog())
    },
    showVisionTutorialDialog: () => dispatch(showVisionTutorialDialog()),
    setLaunchSettingWay: (way, name, id) => dispatch(setLaunchSettingWay(way, name, id))

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EntryDeviceList);